import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IconService {
  darkIcons = true;
  darkIcons$: BehaviorSubject<boolean>;

  constructor() {
    this.darkIcons$ = new BehaviorSubject(this.darkIcons);
  }

  setIconsDark(): void {
    this.darkIcons = true;
    this.darkIcons$.next(this.darkIcons);
  }

  setIconsLight(): void {
    this.darkIcons = false;
    this.darkIcons$.next(this.darkIcons);
  }
}
